import React from 'react';

const MvpItem = ({ item, noClamp = false }) => {
  const itemImageUrl =
    item?.avatar ||
    `${process.env.REACT_APP_ASSETS_URL}/Kpathport/img-kpathport-oval.svg`;
  const title = typeof item === 'string' ? item : item?.title;

  return (
    <div className='flex flex-col w-[90px] tabletH:w-[140px] h-full py-2 tabletH:py-4 items-center justify-start gap-2'>
      <img
        src={itemImageUrl}
        alt={item?.name || 'MVP profile'}
        className='size-[60px] tabletH:size-[80px] rounded-full'
      />

      <div
        className={`typo-b12Strong tabletH:typo-b14Strong text-text-primary text-center ${
          noClamp ? '' : 'line-clamp-2'
        }`}
      >
        {title}
      </div>
    </div>
  );
};

export default MvpItem;
